import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PacoteCampanhaSituacaoMultiselectComponent } from './multiselect';
import { PacoteCampanhaSituacaoPipe } from './pipes';
import { PacoteCampanhaSituacaoBadgeComponent } from './badge';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PacoteCampanhaSituacaoMultiselectComponent,
        PacoteCampanhaSituacaoBadgeComponent,

        // Pipes
        PacoteCampanhaSituacaoPipe
    ],
    exports: [
        PacoteCampanhaSituacaoMultiselectComponent,
        PacoteCampanhaSituacaoBadgeComponent,

        // Pipes
        PacoteCampanhaSituacaoPipe
    ],
    providers: [
        // Pipes
        PacoteCampanhaSituacaoPipe
    ]
})
export class PacoteCampanhaSituacaoModule { }
